import { fetch } from '@/service/fetch/index'

export function login(option) {
  return fetch('/aomi-transport/tsacCustomer/customerLogin', option , 'login')
}

export function logout (option) {
  return fetch('/uc/login/loginOut', option, 'login')
}

export function getResourceVo (option) {
  return fetch('/uc/login/v2/getResourceVo', option, 'login')
}

export function checkUserStatus (option) {
  return fetch('/uc/user/checkUserStatus', option, 'login')
}

export function changePwd (params) {
  return fetch('/uc/user/changePwd', { method: 'post', params: params }, 'login')
}
